/**
 * Website v2 media lives in `public/media/` (register: `public/media/SOURCES.md`),
 * produced by hofsync-org `marketing/ad-production/assets/scripts_2026-10-19/make_web_assets.sh`.
 * File names follow `<name>[-<lang>]-<width>.<ext>`.
 */
export type MediaLang = 'de' | 'en';

export const MEDIA_BASE = '/media/';

/**
 * The films (14-46 MB each) are too big for git, whose `check-added-large-files`
 * hook caps added files at 1,000 KB. They are streamed from a private S3 bucket
 * behind CloudFront (infra/terraform/modules/media_cdn; `terraform output
 * media_cdn_domain`), uploaded with `aws s3 cp` to `hofsync-production-media`.
 * Posters and captions stay in public/media: a cross-origin `<track>` would
 * need CORS and `crossorigin`.
 */
export const MEDIA_CDN = 'https://d1u8vuycpahyg3.cloudfront.net/';

/** Below this viewport width the films load their 720p file, from it the 1080p one. */
export const FILM_HD_MIN_VIEWPORT = 1280;

export const mediaUrl = (file: string): string => `${MEDIA_BASE}${file}`;

export const srcSet = (name: string, widths: readonly number[], ext: string): string =>
  widths.map((w) => `${mediaUrl(`${name}-${w}.${ext}`)} ${w}w`).join(', ');

export const localizedName = (name: string, lang: MediaLang): string => `${name}-${lang}`;

export const filmSrc = (film: string, viewportWidth: number): string =>
  `${MEDIA_CDN}${film}-${viewportWidth >= FILM_HD_MIN_VIEWPORT ? 1080 : 720}.mp4`;

export const toMediaLang = (language: string | undefined): MediaLang =>
  language?.startsWith('en') ? 'en' : 'de';
